"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOrderLog = void 0;
const helpers_1 = require("../../helpers");
const addOrderLog = async (supabase, obj) => {
    if (!obj.created_by)
        obj.created_by = helpers_1.ADMIN_USER_ID;
    const { data, error } = await supabase.from("order_log").insert([obj]);
    if (!error)
        return data;
    return error;
};
exports.addOrderLog = addOrderLog;
